<template>
    <UpdateSubAssembly></UpdateSubAssembly>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UpdateSubAssembly = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/UpdateSubAssembly.vue"
    )
);

export default {
    name: "Project_HelpUpdateSubAssembly", //The name you are in should not equal the name of the component you are importing.
    components: { UpdateSubAssembly, AuthLayout },
};
</script>
